module.exports = __webpack_public_path__ + "img/Devices-background-blue.dbc1b708.svg";